import { buildSession, type SessionMode } from "@/lib/scheduler";
import { NextRequest, NextResponse } from "next/server";

export async function POST(request: NextRequest) {
  try {
    const body = await request.json();
    const { userId, mode = "standard", sessionSize = 20 } = body;

    if (!userId) {
      return NextResponse.json(
        { error: "userId is required" },
        { status: 400 }
      );
    }

    const validModes: SessionMode[] = ["confidence", "standard", "cram"];
    if (!validModes.includes(mode)) {
      return NextResponse.json(
        { error: `Invalid mode. Must be one of: ${validModes.join(", ")}` },
        { status: 400 }
      );
    }

    const session = await buildSession(userId, mode, sessionSize);

    return NextResponse.json(session);
  } catch (error) {
    console.error("Error building session:", error);
    return NextResponse.json(
      { error: error instanceof Error ? error.message : "Failed to build session" },
      { status: 500 }
    );
  }
}
